const VIP_MEDAL_IMAGES = {
  iron: require("assets/play365/images/vip-madels/iron-gcc.webp"),
  copper: require("assets/play365/images/vip-madels/copper-gcc.webp"),
  bronze: require("assets/play365/images/vip-madels/bronze-gcc.webp"),
  silver: require("assets/play365/images/vip-madels/silver-gcc.webp"),
  gold: require("assets/play365/images/vip-madels/gold-gcc.webp"),
};

// Backend tierKey is a slugified level name (e.g. "silver-clover"), so match
// on substring. The programme has five tiers, Iron through Gold: there is no
// Diamond tier, so a legacy/misconfigured "diamond" key resolves to the top
// medal (gold) instead of inventing a tier the brand does not sell.
const VIP_MEDAL_SUBSTRINGS = ["iron", "copper", "bronze", "silver", "gold"];

export function resolveVipMedalKey(tierKey) {
  const key = String(tierKey || "").toLowerCase();
  if (VIP_MEDAL_IMAGES[key]) return key;
  if (key.includes("diamond")) return "gold";
  const match = VIP_MEDAL_SUBSTRINGS.find((tier) => key.includes(tier));
  return match || "iron";
}

export function getVipMedalSrc(tierKey) {
  return VIP_MEDAL_IMAGES[resolveVipMedalKey(tierKey)] || VIP_MEDAL_IMAGES.iron;
}

export default VIP_MEDAL_IMAGES;
